import { EFinancingCompany } from '@if/core/types'
import { clearSelectedCompany } from '@src/contexts/SelectedCompanyProvider'
import { mockLogin } from '@src/data/api/user-api/user-api'
import { markImpersonatedSession, saveUserToken } from '@src/data/providersUtils/UserProviderUtils'

/**
 * Replaces the current session with one issued for a test profile.
 *
 * Reloads the document instead of navigating: the profile's rights, companies and cached queries
 * all have to be rebuilt from the new token, and a client-side navigation would keep the providers
 * and the React Query cache of the session being replaced.
 */
export async function loadTestProfile(username: string, companyIds: EFinancingCompany[]): Promise<void> {
  const { jwt } = await mockLogin({ username, companyIds })

  saveUserToken(jwt)
  markImpersonatedSession()
  clearSelectedCompany()

  window.location.assign('/')
}
